export default {"src":"/_next/static/media/microscope.bc5998c9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};